import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

interface LogoutButtonProps {
  className?: string;
  children?: React.ReactNode;
  onLogout?: () => void;
}

export const LogoutButton: React.FC<LogoutButtonProps> = ({ 
  className = '', 
  children = 'Logout',
  onLogout 
}) => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    console.log('LogoutButton: handleLogout called');
    console.log('LogoutButton: Current localStorage before logout:', localStorage);

    try {
      console.log('LogoutButton: Calling logout function');
      await logout();
      console.log('LogoutButton: Logout function completed');

      // Call custom logout handler if provided
      if (onLogout) {
        console.log('LogoutButton: Calling custom onLogout handler');
        onLogout();
      }

      console.log('LogoutButton: Redirecting to login page');
      // Redirect to login page
      navigate('/login', { replace: true });
    } catch (error) {
      console.error('LogoutButton: Logout failed:', error);
      // Still redirect even if logout fails
      navigate('/login', { replace: true });
    }
  };

  return (
    <button 
      onClick={handleLogout}
      className={className}
      type="button"
    >
      {children}
    </button>
  );
};
